export interface Coordinates {
    lat: number;
    lng: number;
}

export interface Points {
    4564744787788866587: string;
    4564744787788967941: string;
    4564744787826067358: string;
}

export class Bts {
    id: string;
    code: string;
    coverage: string;
    coordinates: Coordinates;
    point_type: string;
    sub_type: string;
    city_istat: string;
    points: Points;
}

export class BtsList {
    NOA?: Bts[];
    BUILDING?: Bts[];
}